import script from "./InspectorSetImg.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorSetImg.vue?vue&type=script&setup=true&lang=js"

import "./InspectorSetImg.vue?vue&type=style&index=0&id=229edb5f&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229edb5f"]])

export default __exports__